import React from "react";
import { useParams } from "react-router-dom";
import CaseSetupForm from "./case-setup-form";

function CaseSetupContainer() {
  const { id, page } = useParams();

  const caseId = React.useMemo(() => {
    if (id) {
      return id;
    }
    return "new";
  }, [id]);

  return <CaseSetupForm caseId={caseId} page={parseInt(`${page ? page : 0}`)} />;
}

export default CaseSetupContainer;
